import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes", isCompression: false });

const useStorage = {
  getSecureLS(key) {
    return ls.get(key);
  },

  setSecureLS(key, value) {
    ls.set(key, value);
  },

  clearSecureLS() {
    ls.clear();
  },

  removeSecureLS(key) {
    ls.remove(key);
  },

  removeAllSecureLS() {
    ls.removeAll();
  },
};

export default useStorage;
